<app-page-shell>
  <app-page-detail-hero
    [eyebrow]="isEditMode ? ('logisticsProjects.form.editEyebrow' | transloco) : ('logisticsProjects.form.newEyebrow' | transloco)"
    [title]="isEditMode ? (project.projectName || ('logisticsProjects.form.editEyebrow' | transloco)) : ('logisticsProjects.form.createTitle' | transloco)"
    [subtitle]="isEditMode ? project.projectNumber || '' : ('logisticsProjects.form.createSubtitle' | transloco)"
    icon="pi pi-briefcase">
    <div actions>
      <p-button [label]="'logisticsProjects.form.cancel' | transloco" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancel()"/>
      <p-button [label]="'logisticsProjects.form.save' | transloco" icon="pi pi-save" [loading]="saving" (click)="save()" [disabled]="saving || (!isEditMode && newProjectPersisted) || !project.projectName?.trim()"/>
    </div>
  </app-page-detail-hero>

  @if (error) { <p-message severity="error" [text]="error" class="block mx-4 mt-3"/> }

  @if (loading) {
    <div class="flex justify-content-center p-6"><i class="pi pi-spin pi-spinner text-3xl text-primary"></i></div>
  } @else {
    <div class="project-form-shell p-fluid">
      <div class="project-form-stack">
      <app-page-form-section icon="pi pi-info-circle" [title]="'logisticsProjects.form.basicTitle' | transloco" [subtitle]="'logisticsProjects.form.basicSubtitle' | transloco">
        <div class="formgrid grid project-form-grid">
          <div class="field col-12 md:col-6 xl:col-6">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-file-edit"></i></p-inputGroupAddon>
              <p-iftalabel><input pInputText [(ngModel)]="project.projectName" name="projectName" required/><label>{{ 'logisticsProjects.form.projectName' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-3 xl:col-3">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
              <p-iftalabel><p-select [options]="projectTypes" [(ngModel)]="project.projectType" optionLabel="label" optionValue="value" styleClass="w-full" (onChange)="onProjectTypeChanged()"/><label>{{ 'logisticsProjects.form.projectType' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-3 xl:col-3">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-sort-amount-up"></i></p-inputGroupAddon>
              <p-iftalabel><p-select [options]="priorities" [(ngModel)]="project.priority" optionLabel="label" optionValue="value" styleClass="w-full"/><label>{{ 'logisticsProjects.form.priority' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-6">
            <p-iftalabel><p-select [options]="sharingModes" [(ngModel)]="project.sharingMode" optionLabel="label" optionValue="value" styleClass="w-full"/><label>Project sharing</label></p-iftalabel>
            <small class="text-color-secondary">Private projects are also visible to sister companies that contribute linked resources or financial records.</small>
          </div>
          @if (!isEditMode) {
            <div class="field col-12">
              <p-inputGroup><p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                <p-iftalabel>
                  <p-select [options]="templates" [(ngModel)]="selectedTemplateCode" name="selectedTemplateCode"
                            optionLabel="templateName" optionValue="templateCode" [loading]="templatesLoading"
                            [showClear]="true" appendTo="body" styleClass="w-full"
                            (onChange)="onTemplateSelected($event.value)">
                    <ng-template #item let-template>
                      <div class="project-option">
                        <span>{{ template.templateName }}</span>
                        <small>{{ template.completionMethod }} | {{ template.milestones?.length || 0 }} milestones</small>
                      </div>
                    </ng-template>
                  </p-select>
                  <label>{{ 'logisticsProjects.form.template' | transloco }}</label>
                </p-iftalabel>
              </p-inputGroup>
              @if (selectedTemplateCode) {
                <small class="text-color-secondary">{{ 'logisticsProjects.form.templateHint' | transloco }}</small>
              }
            </div>
          }
        </div>
      </app-page-form-section>

      <app-page-form-section icon="pi pi-building" [title]="'logisticsProjects.form.clientTitle' | transloco" [subtitle]="'logisticsProjects.form.clientSubtitle' | transloco">
        <div class="formgrid grid project-form-grid">
          <div class="field col-12">
            <app-commercial-party-picker
              [owningCompanyId]="owningCompanyId"
              [value]="commercialPartyReference"
              [required]="true"
              label="Project Commercial Party"
              (valueChange)="onCommercialPartyChange($event)">
            </app-commercial-party-picker>
          </div>
        </div>
      </app-page-form-section>

      <app-page-form-section icon="pi pi-calendar" [title]="'logisticsProjects.form.datesTitle' | transloco" [subtitle]="'logisticsProjects.form.datesSubtitle' | transloco">
        <div class="formgrid grid project-form-grid">
          <div class="field col-12 md:col-4">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
              <p-iftalabel><p-datepicker [(ngModel)]="project.plannedStartAt" name="plannedStartAt" styleClass="w-full" [showIcon]="false"/><label>{{ 'logisticsProjects.form.plannedStart' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-4">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-calendar-clock"></i></p-inputGroupAddon>
              <p-iftalabel><p-datepicker [(ngModel)]="project.plannedEndAt" name="plannedEndAt" styleClass="w-full" [showIcon]="false"/><label>{{ 'logisticsProjects.form.plannedEnd' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-4">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-chart-line"></i></p-inputGroupAddon>
              <p-iftalabel><p-select [options]="completionMethods" [(ngModel)]="project.completionMethod" optionLabel="label" optionValue="value" styleClass="w-full"/><label>{{ 'logisticsProjects.form.progressMethod' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
        </div>
      </app-page-form-section>

      <app-page-form-section icon="pi pi-money-bill" [title]="'logisticsProjects.form.financialTitle' | transloco" [subtitle]="'logisticsProjects.form.financialSubtitle' | transloco">
        <div class="formgrid grid project-form-grid">
          <div class="field col-12 md:col-3">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
              <p-iftalabel><input pInputText [(ngModel)]="project.defaultCurrencyCode" name="defaultCurrencyCode" placeholder="SAR"/><label>{{ 'logisticsProjects.form.currency' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-3">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-chart-bar"></i></p-inputGroupAddon>
              <p-iftalabel><p-inputNumber [(ngModel)]="project.estimatedRevenueAmount" name="estimatedRevenueAmount" mode="currency" [currency]="project.defaultCurrencyCode || 'SAR'" styleClass="w-full"/><label>{{ 'logisticsProjects.form.revenue' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-3">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon>
              <p-iftalabel><p-inputNumber [(ngModel)]="project.estimatedCostAmount" name="estimatedCostAmount" mode="currency" [currency]="project.defaultCurrencyCode || 'SAR'" styleClass="w-full"/><label>{{ 'logisticsProjects.form.cost' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="field col-12 md:col-3">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-verified"></i></p-inputGroupAddon>
              <p-iftalabel><p-inputNumber [(ngModel)]="project.approvedBudgetAmount" name="approvedBudgetAmount" mode="currency" [currency]="project.defaultCurrencyCode || 'SAR'" styleClass="w-full"/><label>{{ 'logisticsProjects.form.budget' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
          </div>
        </div>
      </app-page-form-section>

      <app-page-form-section icon="pi pi-map-marker" [title]="'logisticsProjects.form.locationTitle' | transloco" [subtitle]="'logisticsProjects.form.locationSubtitle' | transloco">
        <div class="formgrid grid project-form-grid">
          <div class="field col-12">
            <p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
              <p-iftalabel>
                <p-select id="projectLocation" appLazyLocationPicker [(ngModel)]="selectedLocation" name="selectedLocation"
                          optionLabel="name" [filter]="true" filterBy="name,shortDescription,longDescription,externalLocationReference"
                          [showClear]="true" appendTo="body" styleClass="w-full" (onChange)="onLocationSelected($event.value)">
                  <ng-template #item let-location>
                    <div class="project-option">
                      <span>{{ location.name }}</span>
                      <small>{{ locationMeta(location) || 'Shipment location' }}</small>
                    </div>
                  </ng-template>
                </p-select>
                <label for="projectLocation">{{ 'logisticsProjects.form.location' | transloco }}</label>
              </p-iftalabel>
              <p-inputGroupAddon>
                <p-button icon="pi pi-plus" severity="secondary" ariaLabel="Create location" (onClick)="openLocationDialog()"/>
              </p-inputGroupAddon>
            </p-inputGroup>
          </div>
        </div>
      </app-page-form-section>

      <app-page-form-section icon="pi pi-align-left" [title]="'logisticsProjects.form.notesTitle' | transloco" [subtitle]="'logisticsProjects.form.notesSubtitle' | transloco">
        <div class="formgrid grid project-form-grid">
          <div class="field col-12">
            <label class="project-editor-label" for="projectDescription">{{ 'logisticsProjects.form.description' | transloco }}</label>
            <p-editor id="projectDescription" [(ngModel)]="project.description" name="description" styleClass="project-rich-editor" [style]="{ height: '220px' }"></p-editor>
          </div>
          <div class="field col-12">
            <label class="project-editor-label" for="projectNotes">{{ 'logisticsProjects.form.internalNotes' | transloco }}</label>
            <p-editor id="projectNotes" [(ngModel)]="project.notes" name="notes" styleClass="project-rich-editor" [style]="{ height: '180px' }"></p-editor>
          </div>
        </div>
      </app-page-form-section>

      <div class="project-form-actions">
        <p-button [label]="'logisticsProjects.form.cancel' | transloco" severity="secondary" [outlined]="true" (click)="cancel()"/>
        <p-button [label]="'logisticsProjects.form.save' | transloco" icon="pi pi-save" [loading]="saving" (click)="save()" [disabled]="saving || (!isEditMode && newProjectPersisted) || !project.projectName?.trim()"/>
      </div>
      </div>
    </div>
  }

</app-page-shell>
